var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStaedteMapPinGrosz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.515,
    height: 241.363,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clp1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M0 0h174.982v228.278H0z",
    shapeRendering: "crispEdges"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#clp1)",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333.422 -180.79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M374.52 268.218c0 25.564 20.812 46.362 46.393 46.362 25.582 0 46.395-20.798 46.395-46.362 0-25.564-20.812-46.362-46.395-46.362-25.582 0-46.393 20.798-46.393 46.362zm12.592 0c0-18.621 15.163-33.77 33.801-33.77 18.639 0 33.803 15.149 33.803 33.77 0 18.621-15.164 33.77-33.803 33.77-18.638 0-33.801-15.149-33.801-33.77zm33.801-86.428c23.071 0 44.782 8.998 61.133 25.336 16.352 16.339 25.358 38.036 25.358 61.092 0 56.831-69.388 128.108-77.333 136.081a12.95 12.95 0 01-9.159 3.769c-3.447 0-6.699-1.338-9.192-3.802-7.912-7.943-77.299-79.235-77.299-136.048 0-23.056 9.006-44.752 25.358-61.092 16.352-16.338 38.063-25.336 61.134-25.336zm0 213.686a.403.403 0 00.272-.098c3.006-3.017 73.627-74.496 73.627-127.16 0-19.691-7.695-38.224-21.666-52.184-13.973-13.962-32.523-21.652-52.233-21.652-19.709 0-38.259 7.69-52.232 21.652-13.972 13.961-21.667 32.494-21.667 52.184 0 52.646 70.621 124.143 73.593 127.126a.426.426 0 00.306.132z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStaedteMapPinGrosz);
export default __webpack_public_path__ + "static/media/Icon_Staedte_Map_Pin_Grosz.7c6656f164457782bfc1dfe701339bf4.svg";
export { ForwardRef as ReactComponent };